import React, { useEffect, useState } from "react";
import { getImageFile, setImageFile } from "../../services/storage/MediaStorage";


const CachedImage = ({ image, imgKey, width, imgClassName, isOnline = navigator.onLine, ...otherProps }) => {
	const [src, setSrc] = useState(null);

	useEffect(() => {
		let isMounted = true;
		let objectUrl = null;

		const assignFromBlob = (blob) => {
			if (objectUrl) URL.revokeObjectURL(objectUrl);
			objectUrl = URL.createObjectURL(blob);
			if (isMounted) setSrc(objectUrl);
		};

		const fetchAndCacheImage = async () => {
			if (!imgKey) {
				if (isMounted) setSrc(image || null);
				return;
			}

			try {
				const localBlob = await getImageFile(imgKey);

				if (localBlob instanceof Blob) {
					assignFromBlob(localBlob);
					return;
				}

				if (!image) {
					if (isMounted) setSrc(null);
					return;
				}

				// When offline wait for connectivity instead of triggering a failed fetch
				if (isOnline === false) {
					return;
				}

				if (isMounted) setSrc(image);

				const response = await fetch(image);
				if (!response.ok) throw new Error("Image fetch failed");

				const blob = await response.blob();
				await setImageFile(imgKey, blob);
				assignFromBlob(blob);
			} catch (error) {
				console.error("Image load failed", error);
				if (isMounted) setSrc(image || null);
			}
		};

		fetchAndCacheImage();

		return () => {
			isMounted = false;
			if (objectUrl) URL.revokeObjectURL(objectUrl);
		};
	}, [imgKey, image, isOnline]);

	if (!src) return null;

	return (
		<img
			loading="lazy"
			width={width}
			className={imgClassName}
			src={src}
			alt=""
			{...otherProps}
		/>
	);
};

export default CachedImage;
